import React, { useState, useRef } from "react"
import axios from "axios"
import { ConfirmModal } from "../../components/Modals/eventanilla/import-cuits/ConfirmModal"
import { useDispatch } from "react-redux"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../redux/actions/app"
import useStyles from "../../components/FilterButton/useStyles"
import { CircularProgress, Typography } from "@mui/material"
import library from "../../utils/Library"

const CuitImporter = () => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const [showLimitModal, setShowLimitModal] = useState(false)

  const fileInputRef = useRef(null)

  const handleOpenConfirm = () => {
    setShowConfirmModal(true)
  }

  const handleConfirmAction = () => {
    setShowConfirmModal(false)
    fileInputRef.current.click()
  }

  const handleConfirmActionWithLimit = () => {
    setShowConfirmModal(false)
    executeUpload(selectedFile, true)
  }
  const executeUpload = async (file, force = false) => {
    const formData = new FormData()
    formData.append("file", file)

    const TOKEN = sessionStorage.getItem("token")

    const URL = `${library.getBaseAPIUrl(
      "xslComposer",
    )}/import-clients-xlsx?force_limit=${force}`

    setIsProcessing(true)
    try {
      const response = await axios.post(URL, formData, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        responseType: "blob",
      })
      const contentDisposition = response.headers["content-disposition"] || ""
      const match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
      const filename = match
        ? decodeURIComponent(match[1].replace(/"/g, ""))
        : `Reporte_importacion_${Date.now()}.xlsx`
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      })
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = downloadUrl
      link.setAttribute("download", filename)
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(downloadUrl)
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Importación finalizada con éxito"))
      setShowLimitModal(false)
    } catch (error) {
      if (error.response) {
        const reader = new FileReader()
        reader.onload = () => {
          const errData = JSON.parse(reader.result)
          if (errData.detail.includes("LIMIT_EXCEEDED")) {
            setSelectedFile(file)
            setShowLimitModal(true)
          } else {
            dispatch(setRequestTextSnackBar())
            dispatch(
              setErrorTextSnackBar("Ocurrió un error durante la importación."),
            )
          }
        }
        reader.readAsText(error.response.data)
      }
    } finally {
      setIsProcessing(false)
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) executeUpload(file, false)
    e.target.value = null
  }

  return (
    <>
      <button
        className={classes.buttonsearch}
        onClick={handleOpenConfirm}
        disabled={isProcessing}
      >
        <div className={classes.typographyButton}>
          {isProcessing ? (
            <CircularProgress size="1.5rem" color="inherit" />
          ) : (
            "Importar CUITs"
          )}
        </div>
      </button>
      <div>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".xlsx, .xls"
          onChange={handleFileChange}
        />

        {showConfirmModal && (
          <ConfirmModal
            openModal={showConfirmModal}
            handleClose={() => setShowConfirmModal(false)}
            handleConfirmFunction={handleConfirmAction}
            title="Confirmar Importación"
            optionalMessage="¿Está seguro que desea importar el archivo de CUITs para realizar de alta de cada uno?"
            message={
              "Si continua con la importación al finalizar el proceso de alta se descargará un nuevo archivo con los detalles."
            }
          />
        )}

        {showLimitModal && (
          <ConfirmModal
            openModal={showLimitModal}
            handleClose={() => setShowLimitModal(false)}
            handleConfirmFunction={handleConfirmActionWithLimit}
            title="Límite de registros excedido"
            message="El archivo excede el limite de registros. Si continúa solo se darán de alta 50 registros, el resto se omitirá."
            optionalMessage="¿Está seguro que desea continuar con la importación?"
          />
        )}
      </div>
    </>
  )
}

export default CuitImporter
